/**************************************************
 * Nombre:       Tarjeta_Docente
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import imagen from '../../Recursos/profe_default.png'
import {NEGRITA} from "../../Constantes";

const Tarjeta_Docente = ({item}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <img src={imagen} width={'100%'} height={'auto'}/>
            </Grid>

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    border: 1,
                    borderColor: '#F7F7F7',
                    p: 1
                }}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography
                        sx={{
                            fontFamily: NEGRITA,
                            textAlign: 'center',
                            lineHeight: 1.2,
                            fontSize: 14,
                            display: '-webkit-box',
                            overflow: 'hidden',
                            WebkitBoxOrient: 'vertical',
                            WebkitLineClamp: 2,
                            height: 36
                        }}>{item.nombre}</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 0.5}}>
                    <Typography sx={{
                        fontSize: 10,
                        color: '#6E6E6E',
                        lineHeight: 1.1,
                        textAlign: 'center',
                        display: '-webkit-box',
                        overflow: 'hidden',
                        WebkitBoxOrient: 'vertical',
                        WebkitLineClamp: 3,
                        height: 36
                    }}>{item.titulo}</Typography>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Tarjeta_Docente